import React, { useContext } from "react";
import ContentData from "../../../../constants/contentFile.json";
import NextIcon from "../../../../assets/images/next-icon.svg";
import EditIcon from "../../../../assets/images/edit-icon.svg";
import { Container } from "react-bootstrap";
import { ProfileManageContext } from "../ProfileInfoView";
import ProfileIcon from "../../../../assets/images/icons/profile-icon.svg";
import ThemeButton from "../../../../components/ThemeButton/ThemeButton";
import CheckBox from "../../../../components/CheckBoxComponent/CheckBox";
import ActivityLog from "../../../../components/ActivityLogComponent/ActivityLog";
import Accordion from "@mui/material/Accordion";
// import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ProfileWithLIneIcon from "../../../../assets/images/profileWithLine.svg";
import "./profileInfo.css";
import routeConstants from "../../../../constants/routeConstants.json";
import Loader from "../../../../components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import ErrorPopup from "../../../../components/PopupAlertError/PopupAlertError";
import InfiniteScroll from "react-infinite-scroll-component";

const ProfileInfo = () => {
  const navigate = useNavigate();
  const {
    name,
    email,
    phoneNumber,
    role,
    notificationPreferences,
    fullImageUrl,
    activityLogData,
    formatDate,
    formatTime,
    spinnerStatus,
    mfa,
    setMfa,

    errorPopup,
    setErrorPopup,
    errorPopupMessage,
    setErrorPopupMessage,
    buttonText,
    setButtonText,
    roleToLogin,
    statusValue,
    setStatusValue,
    getUserDetails,
    isSuperAdmin,
    currentPage,
    hasMore,
    getUserActivityLog,
    accordionExpanded,
    setAccordionExpanded,
  } = useContext(ProfileManageContext);
  return (
    <div className="pageBg">
      <div className="breadCrums boldBreadCrums">
        {ContentData.profilePage.pageTitle}
      </div>

      {spinnerStatus && <Loader />}

      <Container className="profileInfoContainer">
        <div className="profilePageTitleBar">
          <div className="pageTittles">{ContentData.profilePage.profile}</div>

          <div className="pageTitleButtons">
            <ThemeButton
              value={ContentData.profilePage.changePassword}
              className="changePassword"
              // className={ChangePassword} onClick={} type={button}
              onClick={() => {
                navigate(routeConstants.CHANGE_PASSWORD);
              }}
            />
            <ThemeButton
              className="editIcon"
              onClick={() => {
                navigate(routeConstants.EDIT_PROFILE);
              }}
              value={
                <img className="editIcon" src={EditIcon} alt="edit icon" />
              }
            />
          </div>
        </div>
        <div className="profilePicAndDetails">
          <div className="profileImage">
            <div className="avatar">
              {/* {console.log(fullImageUrl)} */}
              {fullImageUrl ? (
                <img
                  className="profileIcon"
                  src={fullImageUrl}
                  alt="Profile Icon"
                />
              ) : (
                <img
                  className="profileIcon"
                  src={ProfileIcon}
                  alt="Profile Icon"
                />
              )}
              {/* <img
                className="profileIcon"
                src={ProfileIcon}
                alt="Profile Icon"
              /> */}
            </div>
          </div>
          <div className="profileDetails">
            <div className="profileDetails-row1">
              <div className="">
                <div className="profileDetailsDataTitle">
                  {ContentData.profilePage.name}
                </div>
                <div className="profileDetailsData">{name}</div>
              </div>
              <div className="">
                <div className="profileDetailsDataTitle">
                  {ContentData.profilePage.emailAddress}
                </div>
                <div className="profileDetailsData">{email}</div>
              </div>
              <div className="">
                <div className="profileDetailsDataTitle">
                  {ContentData.profilePage.phoneNumber}
                </div>
                <div className="profileDetailsData">
                  {phoneNumber ? phoneNumber : "Not added"}
                </div>
              </div>
            </div>
            <div className="profileDetails-row2">
              <div style={{ marginLeft: "2px" }}>
                <div className="profileDetailsDataTitle">
                  {ContentData.profilePage.role}
                </div>
                <div className="profileDetailsData">{role}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="profileNotificationPreference">
          <Accordion
            className="profileAccordion"
            disableGutters
            elevation={0}
            sx={{
              border: "none",
              "&:before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{
                fontSize: "12px",
                backgroundColor: "#F7F8FA",
                fontWeight: "bold",
                color: "#6b7a99",
              }}
            >
              {ContentData.profilePage.notificationPreferance}
            </AccordionSummary>

            <AccordionDetails sx={{ padding: 0 }}>
              <div className="accordionRowGroup">
                {notificationPreferences &&
                  notificationPreferences.map((item, index) => (
                    <div key={index} className="accordionRow">
                      <div className="rowTitle">{item.type}</div>
                      <div className="rowData">
                        <CheckBox
                          label={ContentData.editProfile.sms}
                          check={item.SMS} // Dynamically set the check prop from API data
                          disabled={true}
                          id={`editProfile${item.type
                            .toLowerCase()
                            .replace(" ", "")}Sms`}
                        />
                        <CheckBox
                          label={ContentData.editProfile.email}
                          check={item.Email} // Dynamically set the check prop from API data
                          disabled={true}
                          id={`editProfile${item.type
                            .toLowerCase()
                            .replace(" ", "")}Email`}
                        />
                        <CheckBox
                          label={ContentData.editProfile.website}
                          check={item.Website} // Dynamically set the check prop from API data
                          disabled={true}
                          id={`editProfile${item.type
                            .toLowerCase()
                            .replace(" ", "")}Website`}
                        />
                      </div>
                    </div>
                  ))}
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
        <div className="profileAccountSettings">
          <Accordion
            className="profileAccordion"
            disableGutters
            elevation={0}
            sx={{
              border: "none",
              "&:before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{
                fontSize: "12px",
                backgroundColor: "#F7F8FA",
                fontWeight: "bold",
                color: "#6b7a99",
              }}
            >
              {ContentData.profilePage.accountSettings}
            </AccordionSummary>

            <AccordionDetails sx={{ padding: 0 }}>
              <div className="accordionRowGroup">
                <div className="accordionRow">
                  <div className="rowTitle">
                    <CheckBox
                      label={ContentData.profilePage.multiFactorAuthentication}
                      id="multiFactor"
                      disabled={true}
                      check={mfa === "Email" || mfa === "App"}
                    />
                  </div>
                  <div className="rowData">
                    <CheckBox
                      label={ContentData.profilePage.email}
                      id="multiFactorEmail"
                      disabled={true}
                      check={mfa === "Email"}
                    />
                    <div style={{ marginLeft: "139px" }}>
                      <CheckBox
                        label={ContentData.profilePage.authenticationApp}
                        id="multiFactorAuthApp"
                        disabled={true}
                        check={mfa === "App"}
                      />
                    </div>
                  </div>
                  {/* {ContentData.profilePage.requestQrCode} */}
                </div>
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
        {isSuperAdmin && (
          <div className="profileActivityLog">
            <Accordion
              className="profileAccordion"
              disableGutters
              elevation={0}
              onChange={(event, isExpanded) => setAccordionExpanded(isExpanded)}
              sx={{
                border: "none",
                "&:before": {
                  display: "none",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                sx={{
                  fontSize: "12px",
                  backgroundColor: "#F7F8FA",
                  fontWeight: "bold",
                  color: "#6b7a99",
                }}
              >
                {ContentData.profilePage.activityLog}
              </AccordionSummary>

              <AccordionDetails sx={{ padding: 0 }}>
                <div className="accordionRowGroup">
                  <div className="accordionRow">
                    {accordionExpanded && ( // Only render InfiniteScroll when expanded
                      <InfiniteScroll
                        dataLength={activityLogData.length} // Total items currently loaded
                        next={() => getUserActivityLog(currentPage + 1)} // Load more data
                        hasMore={hasMore} // Indicates if more data exists
                        loader={
                          <div className="loadingIndicator">Loading...</div>
                        } // Loader
                        endMessage={
                          <p style={{ textAlign: "center" }}>
                            No more activity logs
                          </p>
                        }
                      >
                        {activityLogData.map((item, index) => (
                          <ActivityLog
                            key={index}
                            name={item?.name || "-"}
                            date={
                              item?.createdAt ? formatDate(item.createdAt) : "-"
                            }
                            time={
                              item?.createdAt ? formatTime(item.createdAt) : "-"
                            }
                            activityMessage={item?.description || "-"}
                          />
                        ))}
                      </InfiniteScroll>
                    )}
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
        )}
      </Container>

      <ErrorPopup
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            roleToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            getUserDetails();
          }
        }}
      />
    </div>
  );
};

export default ProfileInfo;
